import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";

import styles from "../CarForm/CarForm.module.css";

import initialValues from "./form/initialValues";
import validationSchema from "./form/validationSchema";
import buildCarFormData from "../CarForm/form/buildCarFormData";
import mapCarToForm from "./utils/mapCarToForm";
import SubmitButton from "../../common/SubmitButton";
import carService from "../../../services/api/carService";

import {
    CarHero,
    CarImagePicker,
    CarBasicInfo,
    CarPlateSection,
    CarInitialInfo,
    CarPreview,
} from "../CarForm/components";
import { PiCarProfileFill } from "react-icons/pi";
import notify from "../../../services/notify";
import { useDispatch } from "react-redux";
import { getAllCars } from "../../../redux/car/car-slice";

const EditCar = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { id } = useParams();

    const [loading, setLoading] = useState(true);

    const [previewImage, setPreviewImage] = useState(null);

    const formik = useFormik({

        enableReinitialize: true,
        initialValues,
        validationSchema,

        onSubmit: async (values) => {

            const formData = buildCarFormData(
                values,     
                values.imageFile,      
                values.userId      
            );

            try {
                await carService.updateCar(
                    id,
                    formData
                );

                dispatch(getAllCars());
                notify.success("اطلاعات خودرو با موفقیت بروزرسانی شد.");
                navigate(-1);

            } catch (error) {
                notify.error(error);
            }
        },
    });

    useEffect(() => {

        const loadCar = async () => {

            try {

                const car = await carService.getCar(id);

                formik.setValues(
                    mapCarToForm(car)
                );
                setPreviewImage(car.imageUrl);
            }
            finally {
                setLoading(false);
            }
        };
        loadCar();

    }, [id]);

    if (loading) {
        return (
            <div className={styles.loading}>
                در حال بارگذاری...
            </div>
        );
    }

    return (
        <form
            className={styles.container}
            onSubmit={formik.handleSubmit}
        >
            <CarHero
                title="ویرایش خودرو"
                description="اطلاعات خودرو را ویرایش کنید."
                onBack={() => navigate(-1)}
            />

            <CarImagePicker
                formik={formik}
                previewImage={previewImage}
                setPreviewImage={setPreviewImage}
            />

            <CarBasicInfo

                formik={formik}

            />

            <CarPlateSection
                formik={formik}
            />

            <CarInitialInfo
                formik={formik}
            />

            {/* <CarPreview
                title="پیش نمایش"
                formik={formik}
                previewImage={previewImage}
            /> */}

            {/* <button

                type="submit"

                className={styles.submitBtn}

            >

                ذخیره تغییرات

            </button> */}

            <SubmitButton loading={loading}>
                ذخیره تغییرات
            </SubmitButton>
        </form>

    );

};

export default EditCar;